import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

const Input = ({ onChange, value = '', delay = false, validate, ...props }) => {
  // Ensure initial state is always a string
  const [innerValue, setInnerValue] = useState(() => {
    return value == null ? '' : String(value);
  });

  useEffect(() => {
    // Convert value to string for consistent comparison and storage
    let stringValue = value == null ? '' : String(value);

    if (
      props.doFloor &&
      stringValue !== '' &&
      !Number.isNaN(Number(stringValue))
    ) {
      stringValue = String(Math.floor(Number(stringValue)));
    }

    if (stringValue !== innerValue) setInnerValue(stringValue);
  }, [value]);

  const debouncedOnChange = useCallback(debounce(onChange, delay), [
    onChange,
    delay,
  ]);

  const onInputChange = (event) => {
    if (validate(event)) {
      if (props.doFloor && !Number.isNaN(Number(event.target.value))) {
        event.target.value = String(Math.floor(Number(event.target.value)));
      }
      setInnerValue(event.target.value);

      if (delay) {
        event.persist();
        debouncedOnChange(event);
      } else {
        onChange(event);
      }
    }
  };

  return (
    <input
      className="p-2.5 w-full text-gray-700 bg-gray-50 rounded-lg border border-white focus:ring-blue-500 focus:border-blue-500"
      {...props}
      onChange={onInputChange}
      value={innerValue}
      data-hj-allow
    />
  );
};

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
  delay: PropTypes.number,
};

export default Input;
